// extracted by mini-css-extract-plugin
export default {"loadingOverLay":"app_loadingOverLay__UI6n4","loaderContainer":"app_loaderContainer__QzzEN"};